/** The in-game HUD: top bar, drawers, unit card, orders footer, readouts, overlays, hotkeys. */
export const hud = {
  // ---- top bar
  'top.generalStaff': 'General Staff · {state}',
  'top.inField': 'In the field',
  'top.capitulated': 'Capitulated',
  'top.night': 'Night: sight −1, marching slower, attacks weaker',
  'top.daylight': 'Daylight',
  'top.wx.over': '{season} · over {region}: {word}, {temp}',
  'top.wx.mapCentre': 'the map centre',
  'top.wx.ground': 'Ground: {ground}',
  'top.wx.met': 'Meteorological Service (W)',
  'top.hostClock': 'The host controls the clock',
  'top.resume': 'Resume (Space)',
  'top.pause': 'Pause (Space)',
  'top.speed': 'Speed {label} ({v})',
  'top.industry': 'Industry',
  'top.industry.hint': 'Industry per hour from cities in supply',
  'top.manpower': 'Manpower',
  'top.manpower.hint': 'Manpower pool (thousands of men)',
  'top.research': 'Research',
  'top.research.hint': 'Research points per hour',
  'top.perHour': '/h',
  'top.thousands': 'k',
  'top.vp.row': '{name}: {vp} VP ({pct})',
  'top.vp.capitulated': ' — capitulated',
  'top.vp.goal': 'Hold {pct} of all {sum} VP for 24 h to win.',
  'top.vp.victoryIn': 'Victory in {h}h',
  'top.vp.enemyVictoryIn': 'Enemy victory in {h}h',
  'top.vp.label': 'Victory points',
  'top.vp.team': ' · team {vp}',
  'top.vp.need': ' / {sum} · need {pct}',
  'top.menu': 'Staff menu (Esc)',
  'hud.paused': 'PAUSED',

  // ---- dock
  'dock.aria': 'Staff sections',
  'dock.production': 'Prod.',
  'dock.research': 'Tech',
  'dock.intel': 'Intel',
  'dock.weather': 'Met',
  'dock.production.title': 'Production',
  'dock.research.title': 'Research',
  'dock.intel.title': 'Intelligence',
  'dock.weather.title': 'Meteorological Service',

  // ---- production
  'prod.title': 'Production',
  'prod.sub': '{rate} ind/h · {men}k men',
  'prod.book': 'Order book',
  'prod.lines': '{a}/{b} lines',
  'prod.idle': 'The factories stand idle. Order new formations below.',
  'prod.queued': 'queued',
  'prod.at': 'at {city}',
  'prod.cancel': 'Cancel (industry spent is lost)',
  'prod.deployAt': 'Deploy at',
  'prod.city': '{name} · {kind}',
  'prod.capitalCity': '{name} (capital) · {kind}',
  'prod.noCity': 'No city in supply — production cannot be delivered.',
  'prod.new': 'New formation',
  'prod.requires': 'Requires {tech}',
  'prod.cost': '{type}: {ind} industry, {men}k men',
  'prod.men': '{men}k',

  // ---- research
  'res.title': 'Research',
  'res.sub': '{rate} pts/h · {n}/{total} known',
  'res.none': 'No research ordered',
  'res.chooseBelow': 'choose below',
  'res.eta': '≈ {eta}',
  'res.requires': 'Requires {list}',
  'res.needs': 'Needs {list}',
  'res.adopted': 'Adopted',
  'res.inDevelopment': 'In development',

  // ---- intelligence
  'intel.title': 'Intelligence',
  'intel.sub': { one: '{n} order read so far', other: '{n} orders read so far' },
  'intel.observed': 'Observed',
  'intel.ghosts': 'Ghosts',
  'intel.decoys': 'Decoys',
  'intel.intercepts': 'Intercepted enemy orders',
  'intel.noIntercepts': 'No enemy traffic read. Capture couriers or research cryptanalysis.',
  'intel.showPlan': 'Show the plan on the map',
  'intel.courier': 'COURIER CAPTURED',
  'intel.radio': 'RADIO DECRYPTED',
  'intel.age': '{age} ago · expires {left}',
  'intel.posture': 'Posture → {posture}',
  'intel.order': '{order} → {place}',
  'intel.known': 'Known enemy formations',
  'intel.noContacts': 'No enemy formations on file.',

  // ---- Meteorological Service
  'met.title': 'Meteorological Service',
  'met.sub': 'Bulletin {clock} · D{day}',
  'met.now': 'at sea level · next 24 h {min} … {max} · {wind}',
  'met.chip.title': '{label}: share of the land now',
  'met.rain': 'Rain',
  'met.mud': 'Mud',
  'met.fog': 'Fog',
  'met.snow': 'Snow',
  'met.frozen': 'Frozen',
  'met.outlook': 'Outlook',
  'met.lead': '+{h}h',
  'met.legendNote': 'deeper = likelier · {clock}',
  'met.clickRegion': 'Click a region to look at it',
  'met.hover': '{region}: {word} {chance} %',
  'met.cell': '{word} · {chance} %',
  'met.regions': 'Regions',
  'met.fogCol': 'Fog',
  'met.fogCol.hint': 'Chance of fog at dawn',
  'met.front': 'Along our front',
  'met.latest': 'Latest from the Met Service',
  'met.noWarnings': 'No warnings issued for our front.',

  // ---- hex readout & tools
  'tool.move': 'MOVE',
  'tool.attack': 'ATTACK',
  'tool.retreat': 'RETREAT',
  'tool.move.hint': 'Click the destination hex',
  'tool.attack.hint': 'Click the hex to assault',
  'tool.retreat.hint': 'Click where to fall back to',
  'tool.formations': { one: '{n} formation', other: '{n} formations' },
  'tool.withHHour': ' · with H-hour',
  'tool.keep': 'keep tool',
  'tool.cancel': 'cancel',
  'hex.vp': '{vp} VP',
  'hex.lastKnown': ' (last known)',
  'hex.supply': 'Supply {pct}',
  'hex.divisions': { one: '{n} division', other: '{n} divisions' },
  'hex.own': '{n} own',
  'hex.enemy': '{n} enemy',
  'hex.unobserved': 'unobserved',
  'minimap.title': 'Situation map',

  // ---- selection panel
  'sel.adoptPosture.aggressive': 'Adopt aggressive posture',
  'sel.adoptPosture.balanced': 'Adopt balanced posture',
  'sel.adoptPosture.defensive': 'Adopt defensive posture',
  'sel.orderTo': '{order} → {place}',
  'sel.hhourIn': '{hhour} · in {h}h',
  'sel.courier.motorcycle': 'Motorcycle en route · ~{eta}h · left {age} ago',
  'sel.courier.horse': 'Rider en route · ~{eta}h · left {age} ago',
  'sel.byWire': 'By {channel} · arrives in ~{h}h',
  'sel.issued': 'via {channel} · issued {stamp}',
  'sel.encircled': 'Encircled',
  'sel.noSupply': 'No supply',
  'sel.noSupplyFor': 'No supply {h}h',
  'sel.inBattle': 'In battle',
  'sel.dummy': 'Dummy · poses as {type}',
  'sel.strength': 'Strength',
  'sel.org': 'Organisation',
  'sel.supply': 'Supply',
  'sel.entrenched': 'Entrenched',
  'sel.experience': 'Experience',
  'sel.currentOrder': 'Current order',
  'sel.noOrders': 'No orders — acting on posture ({posture}).',
  'sel.awaiting': 'Awaiting H-hour',
  'sel.inTransit': 'Orders in transit',
  'sel.position': 'Position: {place}.',
  'sel.daysInField': { one: '{n} day in the field.', other: '{n} days in the field.' },
  'sel.miniTitle': '{name} — click to select only this; shift-click to remove',
  'sel.hold.title': 'Hold and dig in — sent at once (H)',
  'sel.tool.title': '{label}: then click the target hex ({key})',
  'sel.posture': 'Posture',
  'sel.channel': 'Channel',
  'sel.channel.auto': 'Auto',
  'sel.channel.auto.hint': 'Telephone inside command radius, else courier (or radio if preferred)',
  'sel.channel.courier': 'Courier',
  'sel.channel.courier.hint': 'Mounted courier along the roads — can be captured',
  'sel.channel.radio': 'Radio',
  'sel.channel.radio.hint': 'Fast, but enemy codebreakers may read it',
  'sel.channel.radio.locked': 'Requires Field Radio',
  'sel.hhour': 'H-hour',
  'sel.hhour.now': 'Now',
  'sel.hhour.now.hint': 'Execute on receipt',
  'sel.hhour.plus': '+{h}h',
  'sel.hhour.dawn': '0500',
  'sel.hhour.dawn.hint': 'Next dawn, 05:00',
  'sel.hhour.custom.hint': 'Choose day and hour',
  'sel.hhour.day': 'Day',
  'sel.hhour.at': 'at',
  'sel.hhour.dayAria': 'H-hour day',
  'sel.hhour.hourAria': 'H-hour',
  'sel.hhour.night': ' · night',
  'sel.operation': 'Operation',
  'sel.operation.placeholder': 'Unnamed',
  'sel.operation.aria': 'Operation name',
  'sel.operation.suggest': 'Suggest a codename',
  'sel.level.1': 'Contact',
  'sel.level.2': 'Identified',
  'sel.level.3': 'Assessed',
  'sel.lastSeen': 'Last seen',
  'sel.observedNow': 'Under observation now',
  'sel.seenAgo': '{age} ago ({stamp})',
  'sel.contactPosition': 'Position',
  'sel.believed': ' (believed)',
  'sel.type': 'Type',
  'sel.dummyFormation': 'Dummy formation',
  'sel.unknown': 'Unknown',
  'sel.heading': 'Heading',
  'sel.headingVal': 'Moving {dir} when last seen',
  'sel.estimate': '≈{pct}',
  'sel.decoyHint': 'Canvas and plywood. Our patrols got close enough to see through it.',
  'sel.unknownStrength': 'Strength unknown. Bring a unit adjacent — or recon — to assess it.',
  'sel.oldReport': 'This report is {age} old. The formation may have moved on.',
  'sel.formations': { one: '{n} formation', other: '{n} formations' },
  'sel.typeCount': '{n} {type}',
  'sel.allegiance': '{adj} · {name}',
  'sel.unknownAllegiance': 'Unknown allegiance',
  'sel.observed': 'Observed',
  'sel.ghost': 'Ghost · {age}',
  'sel.decoyStamp': 'Decoy',
  'sel.attackHint': 'Select your formations and right-click this contact to attack it.',

  // ---- teletype chrome
  'tty.aria': 'Dispatches',
  'tty.title': 'Teletype · Dispatches',
  'tty.filter.all': 'All',
  'tty.filter.front': 'Front',
  'tty.filter.orders': 'Orders',
  'tty.filter.intel': 'Intel',
  'tty.filter.home': 'Home',
  'tty.collapse': 'Collapse',
  'tty.expand': 'Expand history',
  'tty.dayRule': 'DAY {n}',
  'tty.empty': '— LINE OPEN · AWAITING TRAFFIC —',

  // ---- telegram & newspaper chrome
  'tg.head': 'TELEGRAM · GENERAL STAFF',
  'paper.aria': '{masthead}, day {n}',
  'paper.putAway': 'Click to put the paper away',
  'paper.edition': 'Morning edition',
  'paper.no': 'No. {n}',
  'paper.dateline': 'Day {n} · 06:00',
  'paper.price': 'Price 5',

  // ---- overlays
  'staff.kicker': 'STAFF CONFERENCE',
  'staff.title': 'The War Room',
  'staff.clockStopped': ' · clock stopped',
  'staff.return': 'Return to the map',
  'staff.manual': 'Field manual',
  'staff.hotkeys': 'Hotkeys',
  'staff.settings': 'Settings',
  'staff.capitulate': 'Offer capitulation',
  'staff.abandon': 'Abandon campaign',
  'staff.leave': 'Leave the war',
  'sheet.manual': 'Field Manual',
  'sheet.settings': 'Settings',
  'keys.title': 'STANDING ORDERS · KEYBOARD',
  'keys.foot': 'Drag on the map to box-select · Esc closes this card',
  'surrender.title': 'OFFER CAPITULATION?',
  'surrender.text':
    'Our forces will lay down their arms and our territory will pass to the occupiers. This cannot be undone.',
  'surrender.fight': 'Fight on',
  'surrender.capitulate': 'Capitulate',

  // ---- hotkeys (labels) and key names on the caps
  'hk.pause': 'Pause / resume',
  'hk.speed': 'Game speed',
  'hk.move': 'Move tool',
  'hk.attack': 'Attack tool',
  'hk.retreat': 'Retreat tool',
  'hk.hold': 'Hold & dig in (sends at once)',
  'hk.focus': 'Focus camera on selection',
  'hk.esc': 'Cancel tool · clear selection · menu',
  'hk.production': 'Production',
  'hk.research': 'Research',
  'hk.intel': 'Intelligence',
  'hk.met': 'Meteorological Service (weather & forecast)',
  'hk.card': 'This card',
  'hk.rightClick': 'Move / attack the clicked hex',
  'hk.shiftClick': 'Add to selection · keep the tool',
  'hk.pan': 'Pan the map (Shift = faster)',
  'hk.zoom': 'Zoom to the pointer',
  'key.space': 'Space',
  'key.shift': 'Shift',
  'key.click': 'click',
  'key.rightClick': 'Right-click',
  'key.arrows': 'Arrows',
  'key.rightDrag': 'Right-drag',
  'key.wheel': 'Wheel',
} as const;
